import { RedirectCommand, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { HomePageComponent } from './home-page/home-page.component';
import { MarketPageComponent } from './market-page/market-page.component';
import { RouteName } from '../models/enums';
import { RegisterPageComponent } from './register-page/register-page.component';
import { FarmRegisterComponent } from './farm-register/farm-register.component';
import { AuthGuard } from './auth.guard';
import { AdminGuard } from './admin.guard';
import { FarmProfilePageComponent } from './farm-profile-page/farm-profile-page.component';
import { FullCalendarComponent } from './components/full-calendar/full-calendar.component';
import { MapComponent } from './components/map/map.component';
import { UserProfilePageComponent } from './user-profile/user-profile.component';
import { AdminLoginComponent } from './admin-login/admin-login.component';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';
import { AllUsersComponent } from './components/all-users/all-users.component';
import { HasFarmGuard } from './has-farm.guard';
import { FarmListComponent } from './components/farm-list/farm-list.component';
import { AllFarmsPageComponent } from './all-farms-page/all-farms-page.component';
import { CalendarPageComponent } from './calendar-page/calendar-page.component';
import { HelpPageComponent } from './help-page/help-page.component';
import { RedirectPageComponent } from './redirect-page/redirect-page.component';
import { OrganisationProfilePageComponent } from './organisation-profile-page/organisation-profile-page.component';

export const routes: Routes = [
    {path: "", redirectTo: RouteName.home, pathMatch: "full"},
    {path: RouteName.home, component: HomePageComponent},
    {path: RouteName.market, component: MarketPageComponent},
    {path: RouteName.register, component: RegisterPageComponent},
    {path: RouteName.farmRegister, component: FarmRegisterComponent, canActivate: [AuthGuard, HasFarmGuard]},
    {path: 'admin-farm-profile/:farmID', component: FarmProfilePageComponent },
    {path: 'organisation/:slug', component: OrganisationProfilePageComponent },
    {path: 'admin-farm-profile', component: FarmProfilePageComponent, canActivate: [AuthGuard]},
    {path: RouteName.userProfile, component: UserProfilePageComponent, canActivate: [AuthGuard]},
    {path: RouteName.adminLogin, component: AdminLoginComponent},
    {path: RouteName.dashboard, component: DashboardPageComponent, canActivate: [AdminGuard]},
    {path: RouteName.users, component: AllUsersComponent, canActivate: [AdminGuard]},
    {path: RouteName.farms, component: AllFarmsPageComponent},
    {path: RouteName.calendar, component: CalendarPageComponent},
    {path: RouteName.help, component: HelpPageComponent},
    {path: RouteName.redirect, component: RedirectPageComponent},
    {path: '**', redirectTo: RouteName.home}, // Redirect to home for any unknown routes
];
